export const getters = {
  LIST: (state) => state.list,
  PAGE: (state) => state.page,
  LAST_PAGE: (state) => state.lastPage,
  TOTAL: (state) => state.total,
  PAGINATION: (state) => state.pagination,

  MODEL: (state) => state.model,
}
